import React, { Suspense, lazy } from 'react';
import { Spacing } from '../../layout/Spacing/Spacing';
import { Loader } from '../../shared/Loader/Loader';
import IconComponent from '../../shared/IconComponents/IconComponent';

interface IUserProfileDetailCardProps {
    label: string;
    text: string | React.ReactNode | number;
    iconName: string;
}

const IconLoader = lazy(() => import('../IconLoader/IconLoader'));
// const MemoizedIconLoader = React.memo(IconLoader);

export const UserProfileDetailCard: React.FC<IUserProfileDetailCardProps> = ({ label, text, iconName }) => {
    return (
        <div className="user-profile-detail__card">
            <div className="user-profile-detail__card--icon">
                <Suspense
                    fallback={
                        <Spacing marginSpacing={'none'} paddingSpacing={'s'}>
                            <Loader gap={0} color="grey-dark" height={15} width={15} />
                        </Spacing>
                    }
                >
                    {/* <IconLoader iconName={label} iconSize={2} gap={0} /> */}
                    <IconComponent size={2} iconName={iconName} />
                </Suspense>
                <span className="user-profile-detail__card--text">{label} </span>
            </div>
            <div>{text}</div>
        </div>
    );
};
